import React from 'react';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { styled } from '@tmap/mmm-style-guide/src/styled';

import IncentiveCardDetailed from '../incentiveCard/detailed';
import HowItWorksCard from './howItWorksCard';

const HiwContainer = styled(Grid, {
  shouldForwardProp: (p) => p !== 'numOffers',
})(({ theme, numOffers }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.only('sm')]: {
    display: numOffers % 2 > 0 ? 'flex' : 'none',
  },
  [theme.breakpoints.up('md')]: {
    display: numOffers % 3 > 0 ? 'flex' : 'none',
  },
}));

function CommunityOffers(props) {
  const {
    offers = [],
    communitySettings = {},
  } = props;
  const incentiveCards = offers.map((offer, i) => (
    <IncentiveCardDetailed
      incentive={offer}
      key={`offerCard-${offer._id}`}
      placementId={`communityChildOffers-${i}`}
      pageId='community'
      elevation={0}
    />
  ));
  return (
    <Grid spacing={3} container alignItems='stretch'>
      {incentiveCards.map((incentiveCard, i) => (
        <Grid item xs={12} sm={6} md={incentiveCards.length > 1 ? 4 : 6} key={`offer-grid-${i}`}>
          {incentiveCard}
        </Grid>
      ))}
      <HiwContainer
        item
        numOffers={incentiveCards.length}
        xs={12}
        sm={6}
        md={incentiveCards.length > 1 ? 4 : 6}
      >
        <HowItWorksCard communitySettings={communitySettings} />
      </HiwContainer>
    </Grid>
  );
}

export default CommunityOffers;
